import { Html5Entities } from 'html-entities'

const htmlDecode = (input: string) => {
  return new Html5Entities().decode(input)
}

export default htmlDecode
